export const environment = {
  appId: 4,
  appName: "dropaddy",
  IsProd: true,
  baseUrl: "https://dev-api.dropaddy.com/api/party",
  pwaFrontendBaseUrl: "https://dev-app.dropaddy.com",
  insizonBackendBaseUrl: "https://dev-api.insizon.com/api",
  insizonFrontendBaseUrl: "https://dev.insizon.com",
  DropAddyAppId: "690fad57f61d5fd8dc487cd4"
};
